import axios from '@_system/axios/axios.js'
export default {
	path: '/expressstop',
	listexpress(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listexpress', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listcostorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listcostorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/expressstop.expressstop', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
